import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { SharedModalInfoComponent } from '../../../../../shared/modal-info/modal-info.component';
import { FormGroup } from '@angular/forms';
import { PixKeyType } from '../../../models/key-type.enum';
import { Auth } from '../../../../../autentication/Auth';
import { AutenticationService } from '../../../../../autentication/autentication.service';
import { EventTypes } from '../../../../../shared/EventTypes';
import { AppEventDispatcher } from '../../../../../utils/AppEventDispatcher';
import { Util } from '../../../../../utils/util';
import { PixKey } from '../../../models/key.model';
import { PixKeysClaimService } from '../../keys-claim.service';

@Component({
	selector: 'app-pix-keys-list-assignature-claim',
	templateUrl: './assignature-claim.component.html',
	styleUrls: ['./assignature-claim.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixKeysListAssignatureClaimComponent implements OnInit {

	public submited = false;
	public form: FormGroup;
	public selectedPixKey: PixKey;
	public guid = '';

	constructor(
		private router: Router,
		public dialog: MatDialog,
		private autenticationService: AutenticationService,
		private pixKeysClaimService: PixKeysClaimService
	) {}

	ngOnInit() {
		this.selectedPixKey = this.pixKeysClaimService.getPixKey();
		this.guid = Util.generateGUID();

		if (!this.selectedPixKey || !this.selectedPixKey.sequencialReividicacao) {
			this.goToList();
		}
	}

	onSetSignatureForm(form: FormGroup) {
		this.form = form;
	}

	submit(message: boolean) {
		this.submited = message;

		if (this.submited && this.form.valid) {
			this.addAuthToken();
			this.sendAssignature();
		}
	}

	addAuthToken() {
		if (this.form.value.token) {
			Auth.passToken = this.form.value.token;
		}
	}

	addAuthSignature() {
		if (this.form.value.eletronicSignature) {
			Auth.assinaturaEletronica = this.form.value.eletronicSignature;
		}
	}

	sendAssignature() {
		this.autenticationService.sendDigitalSignature(this.form.value.eletronicSignature).subscribe(data => {
			if (data.Sucesso) {
				this.addAuthSignature();
				this.sendRequest();
			}
		}, error => {
			this.handleError(error);
		});
	}

	sendRequest() {
		if (this.selectedPixKey.paraConcluir) {
			this.sendRequestFinish();
		} else {
			this.sendRequestResponse();
		}
	}

	sendRequestResponse() {
		this.pixKeysClaimService.postResponse(this.selectedPixKey.sequencialReividicacao, !this.selectedPixKey.cancelarReividicacao).subscribe(data => {
			if (data.Sucesso) {
				if (this.selectedPixKey.cancelarReividicacao) {
					this.openModalDecline();
				} else {
					this.openModalSuccess();
				}

				this.router.navigate(['pix/chaves/listar']);
			}
		}, error => {
			this.handleError(error);
		});
	}

	sendRequestFinish() {
		if (this.selectedPixKey.respostaConcluir) {
			this.pixKeysClaimService.postComplete(this.selectedPixKey.sequencialReividicacao).subscribe(data => {
				if (data && data.Existe && data.Sucesso) {
					this.showModalClaimComplete();
				}
			}, error => { this.handleError(error); });
		} else {
			this.pixKeysClaimService.postCancel(this.selectedPixKey.sequencialReividicacao).subscribe(data => {
				if (data && data.Existe && data.Sucesso) {
					this.showModalCancelComplete();
				}
			}, error => { this.handleError(error); });
		}
	}

	openModalDecline() {
		const dialogRef = this.dialog.open(SharedModalInfoComponent, {
			width: '287px',
			data: {
				title: 'A chave foi mantida',
				topText: this.getTopText(),
				btnName: 'Fechar',
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			this.router.navigate(['pix/chaves/listar']);
		});
	}

	openModalSuccess() {
		const dialogRef = this.dialog.open(SharedModalInfoComponent, {
			width: '287px',
			data: {
				title: this.selectedPixKey.tipoReividicacao === 'PORTABILIDADE' ? 'Portabilidade aceita' : 'A chave agora pertence a outra pessoa',
				topText: this.getTopText(),
				btnName: 'Fechar',
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			this.router.navigate(['pix/chaves/listar']);
		});
	}

	getTopText(): string {
		switch (this.selectedPixKey.tipoChave) {
			case PixKeyType.CPF:
				return 'CPF: ' + Util.formatCpfCnpj(this.selectedPixKey.codigo);
			case PixKeyType.CNPJ:
				return 'CNPJ: ' + Util.formatCpfCnpj(this.selectedPixKey.codigo);
			case PixKeyType.EMAIL:
				return 'E-mail: ' + this.selectedPixKey.codigo;
			case PixKeyType.PHONE:
				return 'Telefone celular: ' + Util.formatPhone(this.selectedPixKey.codigo);
			case PixKeyType.EVP:
				return 'Chave aleatória: ' + this.selectedPixKey.codigo ;
			case PixKeyType.MANUAL:
				return 'Manual: ' + this.selectedPixKey.codigo ;
		}
	}

	showModalClaimComplete() {
		this.dialog.open(SharedModalInfoComponent, {
			width: '400px',
			data: {
				title: 'Processo de reivindicação concluído com sucesso.',
				topText: this.getTopText(),
				text: `Agora, usuários do Pix podem fazer pagamentos para você informando essa chave, sem a necessidade de digitar seus dados.`,
				btnBackName: 'Fechar'
			}
		});
		this.goToList();
	}

	showModalCancelComplete() {
		this.dialog.open(SharedModalInfoComponent, {
			width: '400px',
			data: {
				title: 'Processo de reivindicação cancelada com sucesso.',
				topText: this.getTopText(),
				btnBackName: 'Fechar'
			}
		});
		this.goToList();
	}

	handleError = (error) => AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
	goToList = () => this.router.navigate(['pix/chaves/listar']);
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/keys/list/assignature-claim/assignature-claim.component.ts